import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

// *******************************************************************
// The Google Analytics Measurement ID is now loaded from environment variables.
// *******************************************************************
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const Analytics = () => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  // Effect for initializing GA based on Cookiebot consent
  useEffect(() => {
    const checkCookiebotConsent = () => {
      // Do not initialize if the measurement ID is not set
      if (!GA_MEASUREMENT_ID) {
        console.error("Google Analytics Measurement ID is not set.");
        return;
      }
      // Check if Cookiebot is loaded and if the user has consented to statistics
      if (window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.statistics) {
        // If not already initialized, initialize GA
        if (!initialized) {
          ReactGA.initialize(GA_MEASUREMENT_ID);
          setInitialized(true);
          if (process.env.NODE_ENV === 'development') {
            console.log("GA Initialized");
          }
        }
      }
    };

    // Check for consent as soon as the component mounts
    checkCookiebotConsent();

    // Add event listener for when a user accepts cookies
    window.addEventListener('CookiebotOnAccept', checkCookiebotConsent);

    // Cleanup: remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('CookiebotOnAccept', checkCookiebotConsent);
    };
  }, [initialized]); // This effect depends on the 'initialized' state

  // Effect for tracking pageviews when the route changes
  useEffect(() => {
    // Only track pageviews if GA has been initialized
    if (initialized) {
      // Send a pageview event with the new path
      ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
      if (process.env.NODE_ENV === 'development') {
        console.log(`Tracked Pageview: ${location.pathname + location.search}`);
      }
    }
  }, [initialized, location]); // This effect runs when 'initialized' or 'location' changes

  return null; // This component does not render anything visible
};

export default Analytics;